// extracted by mini-css-extract-plugin
module.exports = {"form":"Subscription_form__2xlnK","input":"Subscription_input__22f5R","btn":"Subscription_btn__pjEwG"};